import { useTranslation } from 'react-i18next';
import { columnsDividends } from '../../helpers/columnsOpportunity';
import { deleteDividend } from '../../helpers/dividend';
import { TableLayout } from '../../layout/TableLayout';

export const AdminDividendsTable = ({ rows, setReloadData }) => {
    const { t } = useTranslation('global');

    const onDeleteClick = async (e) => {
        const deleted = await deleteDividend(
            e,
            t('delete.successMsg'),
            t('delete.errorMsg'),
            t('delete.cancelButton'),
            t('delete.confirmButton'),
            t('opportunities.deleteConfirmDividend')
        );
        if (deleted) {
            setReloadData(prevState => !prevState);
        }
    };

    const columns = columnsDividends(t, onDeleteClick);

    return (
        <TableLayout
            rows={rows}
            columns={columns}
            title='dividendsClub'
        />
    );
};
